export type Testimonial = {
  quote: string
  author: string
  role: string
  avatar?: string
}

export const shortTestimonials: Testimonial[] = [
  {
    quote:
      'The rotation structure made it easier to keep players active throughout the clinic instead of having several people waiting for their next turn.',
    author: 'Jason M.',
    role: 'Austin, Texas, USA',
  },
  {
    quote:
      'Having easier and harder versions of the same drill helped me adjust the activity to the players in front of me without stopping the whole group.',
    author: 'Sarah R.',
    role: 'Orlando, Florida, USA',
  },
  {
    quote:
      'The session card helped me move from a skill drill into a game situation and then live play, without having to figure out the next activity while coaching.',
    author: 'Michael T.',
    role: 'Phoenix, Arizona, USA',
  },
]

export const moreTestimonials: Testimonial[] = [
  {
    quote:
      'I found it useful to have the focus of the session, the drill sequence, and the coaching cues together in one place.',
    author: 'Emily B.',
    role: 'Tampa, Florida, USA',
  },
  {
    quote:
      'We used the session cards as a planning resource alongside our existing recreational pickleball program.',
    author: 'David K.',
    role: 'Dallas, Texas, USA',
  },
  {
    quote:
      'The beginner and intermediate variations gave us a practical way to adapt activities for mixed-level groups.',
    author: 'Amanda C.',
    role: 'San Diego, California, USA',
  },
]
